import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import EditButton from 'modules/Report/components/EditButton';
import store from 'store';

import {
	StyledGoalsEditButton,
	StyledGoalsEditButtonWrap,
	StyledGoalsEditButtonwWrap,
} from './styled';

interface PropsType {
	isEditing?: boolean;
	onSetIsEditing: (value: boolean) => () => void;
}

function GoalsEditButton({ isEditing, onSetIsEditing }: PropsType) {
	const { t } = useTranslation();
	if (!store.isSelfStudentView) return null;

	return (
		<StyledGoalsEditButtonWrap isEditing={isEditing}>
			{isEditing ? (
				<StyledGoalsEditButtonwWrap>
					<StyledGoalsEditButton color="primary" variant="outlined" onClick={onSetIsEditing(false)}>
						{t('shared.cancel')}
					</StyledGoalsEditButton>
					<StyledGoalsEditButton color="primary" variant="contained" type="submit">
						{t('shared.save')}
					</StyledGoalsEditButton>
				</StyledGoalsEditButtonwWrap>
			) : (
				<EditButton handleClick={onSetIsEditing(true)} size={24} />
			)}
		</StyledGoalsEditButtonWrap>
	);
}

export default observer(GoalsEditButton);
